export const SET_PROFILE_SUCCESS = 'SET_PROFILE_SUCCESS'
export const SET_PROFILE_FAIL = 'SET_PROFILE_FAIL'
export const SET_PROFILE_CLEAR_DATA = 'SET_PROFILE_CLEAR_DATA'
